import { api } from "../../lib/api";

export interface SafeUser {
  id: string;
  email: string;
  fullName: string | null;
  role: "user" | "admin" | "commercial";
  emailVerified: boolean;
  totpEnabled: boolean;
  createdAt: string;
}

export interface TokenBundle {
  accessToken: string;
  refreshToken: string;
  expiresIn: number;
  user: SafeUser;
}

export const login = (body: { email: string; password: string; totp?: string }) =>
  api<TokenBundle>("/auth/login", { method: "POST", body });

export const fetchMe = () => api<{ user: SafeUser }>("/me");

export const totpSetup = () =>
  api<{ secret: string; otpauthUri: string }>("/auth/totp/setup", { method: "POST" });

export const totpEnable = (code: string) =>
  api<{ ok: true }>("/auth/totp/enable", { method: "POST", body: { code } });

export const totpDisable = (code: string) =>
  api<{ ok: true }>("/auth/totp/disable", { method: "POST", body: { code } });
